/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
// import EditActionModel from '../Modals/EditModule'
import CreateModule from '../Modals/CreateModule'
import EditModule from '../Modals/EditModule'
// import EditPartnerModel from '../Modals/EditModule'
// import EditActionModel from '../Modals/EditModule'

export default function DataTableData() {
  const AppService = useAppServices()
  const params = useParams()
  const [apps, setApps] = useState()
  const [appData, setappData] = useState({})
  const [events, setEvents] = useState([])
  const [loader, setloader] = useState(true)
  const [allStaff, setAllStaff] = useState([])
  const [staff, setStaff] = useState()
  const [tasks, setTasks] = useState()
  const [app_collection, setApp_collection] = useState([])
  const [appTriggerModel, setAppTriggerModel] = useState([])
  const [modules, setModules] = useState([])
  const [AppData, setAppData] = useState({})

  const getModules = async () => {
    // Check if document exists
    const { response } = await AppService.partner_module.get({
      query: `partner_id=${params.partner_id}`,
    })

    console.log('response_modules', response?.data)

    if (response) {
      setModules(response?.data[0]?.partner_data)
      setAppData(response?.data)
      setloader(false)
    }
  }

  console.log('modules', modules)

  const onLoad = () => {
    getModules()
  }
  useEffect(onLoad, [modules])

  const handlePartnerDelete = async (index) => {
    modules.splice(index, 1) // remove entry at index

    console.log('modules', modules)

    const updatedPayload = {
      partnerId: params.partner_id,
      partner_data: modules,
    }

    const res = await AppService.partner_module.update({
      // use update, not delete
      payload: updatedPayload,
    })

    if (res?.success) {
      setModules(modules) // update state
      getModules()
      handleRefresh()
    }
  }

  console.log('modules?.[0]?.partner_data', modules?.[0]?.partner_data)

  return {
    loader: loader,
    appData: appData,
    apps: apps,
    modules: modules,
    allStaff: allStaff,
    events: events,
    handleRefresh: onLoad,

    dataTableData: {
      columns: [
        { Header: 'name', accessor: 'name' },
        { Header: 'description', accessor: 'description' },
        { Header: 'Action', accessor: 'action' },
      ],
      rows: modules?.map((data, index) => ({
        name: data.name,
        description: `${data?.description.substring(0, 10)}...`,
        action: (
          <MDBox>
            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handlePartnerDelete(index)}
            >
              Delete
            </MDButton>
            {/* <EditActionModel
              editData={data}
              index={index}
              appData={appData}
              handleRefresh={onLoad}
              // appCollections={getAppsCollection('actions')}
            /> */}

            <EditModule handleRefresh={onLoad} index={index} appData={AppData} editData={data} />
          </MDBox>
        ),
      })),
    },
  }
}
